export default __webpack_public_path__ + "static/media/chantilly5.8fb8715c.jpg";